const info = {
  fname: "KEVIN",
  lname: "PHILIP",
  title: "SOFTWARE ENGINEERING STUDENT",
};

const projects = {};

export default info;
